import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Input from '../../common/Input/index'
import Button from '../../common/Button/index'
import PropTypes from 'prop-types'
import { PiEyeSlashFill } from 'react-icons/pi'
import { IoMdEye } from 'react-icons/io'

const LoginForm = ({ onSubmit, error, loading }) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)

  const handleSubmit = e => {
    e.preventDefault()
    onSubmit({ email, password })
  }

  return (
    <form onSubmit={handleSubmit} className="w-full mx-auto p-2 sm:p-4 md:p-6">
      <h2 className="text-center text-dark text-xl sm:text-2xl font-semibold mb-4 sm:mb-6">Admin Login</h2>
      <div className="flex flex-col gap-3 sm:gap-4">
        <Input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="Enter email"
          className="text-sm sm:text-base"
          required
        />
        <Input
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={e => setPassword(e.target.value)}
          icon={
            showPassword ? (
              <IoMdEye onClick={() => setShowPassword(prev => !prev)} className="cursor-pointer text-lg sm:text-xl" />
            ) : (
              <PiEyeSlashFill onClick={() => setShowPassword(prev => !prev)} className="cursor-pointer text-lg sm:text-xl" />
            )
          }
          placeholder="Enter password"
          className="text-sm sm:text-base"
          required
        />
        {error && (
          <div className="text-danger text-xs sm:text-sm text-center p-2 sm:p-3 bg-red-100 rounded" role="alert">
            {error}
          </div>
        )}
        {loading && (
          <Button variant="primary" type="submit" className="mt-2 text-sm sm:text-base py-2 sm:py-3" disabled>
            Loading...
          </Button>
        )}
        {!loading && (
          <Button variant="primary" type="submit" className="mt-2 text-sm sm:text-base py-2 sm:py-3">
            Login
          </Button>
        )}
      </div>
      {/* <Link to="/register">
        <Button variant="link" className="mt-3 sm:mt-4 text-sm sm:text-base">
          Sign Up
        </Button>
      </Link> */}
    </form>
  )
}

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  loading: PropTypes.bool,
}

export default LoginForm
